<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app-bar dark color="primary" :clipped-left="appsBar.clipped" app>
    <selectMissionDialog/>
    <v-toolbar-title class="headline">
      <v-avatar size="36">
        <v-img src="img/icons/arks_logo.png"></v-img>
      </v-avatar>
      <span class="font-weight-light header">{{appsBar.title}}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-progress-circular v-if="appsBar.loading_status" :width="3" color="white" indeterminate></v-progress-circular>
    <v-btn id="pwa" fab elevation="0" color="primary">
      <v-icon>fas fa-mobile</v-icon>
    </v-btn>
    <v-btn fab elevation="0" color="primary" @click="clickSelectMissionDialog">
      <v-icon>fab fa-wpforms</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import selectMissionDialog from '../../dialog/selectMissionDialog/selectMissionDialog.vue'
export default {
  name: 'appsBar',
  data: () => ({
    appsBar: {}
  }),
  components: {
    selectMissionDialog
  },
  created () {
    this.appsBar = this.$store.state.appsBar
  },
  methods: {
    clickSelectMissionDialog () {
      this.$store.commit('setSelectMissionDialogStatus', true)
    }
  }
}
</script>

<style scoped>

</style>
